import {parseCookies} from 'nookies'
import {useMutation} from '@apollo/client'
import {CartItemUpdateInput, GetCartQuery} from '_app/types/api'
import {useUpdateCartItemsMutation} from '_app/graphql/mutations/cart/UpdateCartItemsDocument'
import toast from '_app/utils/toast'
import {REMOVE_ITEM_FROM_CART} from '_app/graphql/mutations/cart/RemoveItemFromCart'
import {CartItem} from '../types'
import {cart} from '../../../_app/cache'
import RequestHelper from '../../../helpers/RequestHelper/RequestHelper'
import {useRouter} from 'next/router'

export const useCartItems = (data: GetCartQuery | undefined, setData: any = null) => {
  const { cartId } = parseCookies()
  const { locale } = useRouter()
  const [updateCartItemsMutation] = useUpdateCartItemsMutation()
  const [removeItemFromCart, { loading }] = useMutation(REMOVE_ITEM_FROM_CART)
  const deleteProductHandler = async (item: CartItem) => {
    return await removeItemFromCart({
      variables: {
        cartId,
        cartItemId: item?.id,
      },
      onCompleted: ((res: any) => {
        if (res) {
          RequestHelper.onComplete(res, 'removeItemFromCart', locale)
          cart(res?.removeItemFromCart)
          if (setData) {
            setData(res?.removeItemFromCart)
          }
        }
      })
    }).catch((error) => RequestHelper.internalServerError(error))
  }

  const quantityChangeHandler = async (itemId: string, quantity: number) => {
    const cartItems: CartItemUpdateInput[] = (data?.cart?.items || []).map(
      item => ({
        cart_item_uid: item?.uid,
        quantity: item?.id === itemId ? quantity : item?.quantity,
      })
    )

    try {
      return await updateCartItemsMutation({
        variables: {
          cart_id: cartId,
          cart_items: cartItems,
        },
        onCompleted: (res: any) => {
          if (res) {
            cart(res?.updateCartItems)
            if (setData) {
              setData(res?.updateCartItems)
            }
          }
        }
      })
    } catch (error) {
      toast(error)
    }
  }

  return { quantityChangeHandler, deleteProductHandler, loading }
}
